import { ColorSAP, Typography } from "../../ontego-ui";
import { styled } from "@mui/material";

const Styled = {};

Styled.FunctionBoxContainer = styled("div")(() => ({
  position: "relative",
  cursor: "pointer",
  boxSizing: "border-box",
  padding: 16,
  width: "100%",
  height: 106,
  borderRadius: 12,
  background: `linear-gradient(${ColorSAP.neutral[0]}, ${ColorSAP.neutral[0]}) padding-box, linear-gradient(to right, ${ColorSAP.neutral[90]}, ${ColorSAP.primary[70]}) border-box`,
  border: "2px solid transparent",
  transition: "all ease-in-out 400ms",
  "&:hover": {
    border: `2px solid ${ColorSAP.primary[70]}`,
    background: ColorSAP.primary[70],
  },
  "&:active": {
    border: `2px solid ${ColorSAP.primary[80]}`,
    background: ColorSAP.primary[80],
    transition: "none",
  },
}));

Styled.FunctionBoxIconLabel = styled("div")(({ isHover }) => ({
  display: "flex",
  justifyContent: "space-between",
  "& svg": {
    width: 32,
    height: 32,
    color: isHover ? ColorSAP.neutral[0] : ColorSAP.primary[70],
    transition: "all .3s ease-in-out",
  },
}));

Styled.FunctionBoxCollectionIcon = styled("div")(
  ({ isAdded, isAddToCollectionHover }) => ({
    position: "absolute",
    cursor: "pointer",
    top: 15,
    right: 12,
    width: 32,
    height: 32,
    padding: 4,
    boxSizing: "border-box",
    borderRadius: "50%",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",

    background: isAddToCollectionHover
      ? isAdded
        ? ColorSAP.secondary[20]
        : ColorSAP.primary[30]
      : "transparent",
    transition: "0.15s all ease",
    "& svg": {
      width: 24,
      height: 24,
      color: isAdded
        ? isAddToCollectionHover
          ? ColorSAP.secondary[50]
          : ColorSAP.secondary[40]
        : isAddToCollectionHover
          ? ColorSAP.primary[60]
          : ColorSAP.primary[40],
    },
  }),
);

Styled.FunctionBoxTypography = styled(Typography)(() => ({
  width: "fit-content",
  cursor: "pointer",
  letterSpacing: -0.53,
  transition: "all .2s ease-in-out",
  marginLeft: 6,
}));

Styled.FunctionBoxChipContainer = styled("div")(() => ({
  display: "flex",
  alignItems: "center",
}));

export default Styled;
